import { makeStyles } from "@material-ui/styles";

const drawerWidth = 325;

const gameContainerStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		height: "100%"
	},
	appFrame: {
		position: "relative",
		display: "flex",
		width: "100%"
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0
	},
	drawerPaper: {
		background: "transparent",
		width: drawerWidth,
		borderLeft: `1px solid ${theme.palette.border.primary}`,
		padding: 10
	},
	content: {
		flexGrow: 1,
		marginRight: 0
	},
	gameSummaryContainer: {
		height: 86
	},
	drawerPaperMobile: {
		backgroundColor: `${theme.palette.menu.backgroundColor} !important`,
		borderLeft: "none"
	},
	mobilePlayListBtn: {
		position: "absolute",
		[theme.breakpoints.down("md")]: {
			top: 15,
			right: 15
		},
		[theme.breakpoints.only("xs")]: {
			top: 10,
			right: 10
		},
		color: theme.palette.menu.backgroundColor,
		backgroundColor: "#fff",
		borderRadius: "5px",
		width: "40px",
		height: "40px",
		padding: 0,
		"&:hover": {
			backgroundColor: "#fff"
		}
	},
	mobilePlayListDrawerBtn: {
		top: 17,
		right: 8
	}
}));

export default gameContainerStyles;
